import React from "react"
import { useTranslation } from "react-i18next"

const FuelYourSavings = () => {
  const { t } = useTranslation("fuelcardRequest")

  const FUEL_SAVINGS_INFO = [
    {
      header: t("noCreditcardCheckRequired"),
      info: t("fuelInfo1")
    },
    {
      header: t("hassleFreeSavings"),
      info: t("fuelInfo2")
    },
    {
      header: t("usaaPerkBenefits"),
      info: t("fuelInfo3")
    }
  ]

  return (
    <div className="fuel-your-savings">
      <p className="section-label">{t("fuelYourSavings")}</p>
      <div className="fuel-saving-box">
        {FUEL_SAVINGS_INFO.map((savings) => (
          <div key={savings.header} className="fuel-saving">
            <p className="saving-header">{savings.header}</p>
            <p className="saving-info">{savings.info}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FuelYourSavings
